import { Card, Grid, Typography } from '@mui/material';
import { JSX } from 'react';

interface UpsellCardProps {
  art: JSX.Element;
  title: string;
  cardStyle?: React.CSSProperties;
  mobile?: boolean;
}

const UpsellCard: React.FC<UpsellCardProps> = ({ art, title, cardStyle, mobile }) => {
  const extraStyles: React.CSSProperties | undefined = mobile ? { padding: '10px' } : undefined;
  return (
    <Card
      sx={{
        width: '30%',
        minWidth: mobile ? '100px' : '150px',
        maxWidth: '150px',
        flexDirection: 'column',
        textAlign: 'center',
        aspectRatio: 1,
        boxShadow: mobile ? 'none' : undefined,
        ...extraStyles,
        ...cardStyle,
      }}
      className='content-card'>
      <Grid
        display='flex'
        alignItems='center'
        justifyContent='center'
        sx={{ '& img': { maxWidth: '100%', maxHeight: '100%' } }}>
        {art}
      </Grid>
      <Typography mt={'20px'} variant={mobile ? 'p14Bold' : 'p18Bold'} color='primary'>
        {title}
      </Typography>
    </Card>
  );
};
export default UpsellCard;
